import { Navigate } from "react-router-dom";
import Admin from "./pages/Admin";
import Chatbot from "./pages/Chatbot";
import ClientPortal from "./pages/Portal";
import PlatformPrivacyPolicyPage from "./pages/PlatformPrivacyPolicyPage";
import { marketingRoutes } from "./marketing/marketingRoutes";

export const appRoutes = [
  ...marketingRoutes,
  { path: "/admin", element: <Admin /> },
  { path: "/portal", element: <ClientPortal /> },
  { path: "/portal/:slug", element: <ClientPortal /> },
  { path: "/confidentialite-plateforme", element: <PlatformPrivacyPolicyPage /> },
  { path: "/c/:slug", element: <Chatbot /> },
  { path: "/c/:slug/:conversationId", element: <Chatbot /> },
  { path: "*", element: <Navigate to="/" replace /> },
];
